import React from 'react';

import AsyncSelect from 'react-select/async';

const NameFilter = ({
  onFilterChange,
  selectedNames,
  companyId,
  displayInterviewMode,
}) => {
  const handleSelectChange = (selectedCandidates) => {
    onFilterChange(selectedCandidates);
  };
  const promiseOptions = (inputValue: string) => {
    const url = `/api/users/company/${companyId}/candidates/filter-by-name?type=${displayInterviewMode}${
      inputValue ? '&searchName=' + inputValue : ''
    }`;

    return fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        return res.data;
      });
  };

  return (
    <AsyncSelect
      placeholder="Select Candidates"
      isMulti
      cacheOptions
      defaultOptions
      loadOptions={promiseOptions}
      instanceId="1"
      onChange={handleSelectChange}
      components={{
        IndicatorSeparator: () => null,
        LoadingIndicator: () => null,
      }}
      defaultValue={selectedNames}
    />
  );
};

export default NameFilter;
